<script lang="ts">
    export let style: string = '';
</script>

<div class="vehicle-one-value" {style}>
    <slot />
</div>

<style>
    .vehicle-one-value {
        width: 100%;
        column-gap: 10px;
        display: flex;
        align-items: center;
        /*background-color: #1c90b4;*/
        /*color:var(--list-element-header-color-inactive);*/
    }
</style>
